import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// 1. IMPORT PLUGIN BLUETOOTH
import { BluetoothSerial } from '@awesome-cordova-plugins/bluetooth-serial/ngx';

if (environment.production) {
  enableProdMode();
}

window.addEventListener('error', (e) => {
  document.body.innerHTML =
    '<pre style="padding:16px;color:red;">' +
    'GLOBAL ERROR:\n' +
    e.message +
    '</pre>';
});

window.addEventListener('unhandledrejection', (e: any) => {
  document.body.innerHTML =
    '<pre style="padding:16px;color:red;">' +
    'UNHANDLED PROMISE:\n' +
    (e.reason?.message || e.reason) +
    '</pre>';
});


bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    
    // 2. DAFTARKAN PROVIDER DI SINI (WAJIB ADA)
    BluetoothSerial 
  ],
});